export const API_URL = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL
  : "http://192.168.1.23:8080/v1/api";
export const REDIRECT_URL = process.env.REACT_APP_REDIRECT_URL
  ? process.env.REACT_APP_REDIRECT_URL
  : "http://localhost:3000";
